import * as React from 'react';
import { ChevronLeft, ChevronRight, DoubleChevronLeft, DoubleChevronRight, } from '@wix/wix-ui-icons-common/on-stage';
import { st, classes } from '../Pagination.st.css';
import { DataHooks } from '../constants';
import { getId, upperCaseFirst } from '../utils';
export const NavButton = ({ disabled, type, currentPage, totalPages, previousLabel, nextLabel, firstLabel, lastLabel, pageUrl, handlePageClick, id, }) => {
    const isDisabled = disabled ||
        ((type === "first" /* ButtonType.First */ || type === "previous" /* ButtonType.Prev */) &&
            currentPage <= 1) ||
        ((type === "last" /* ButtonType.Last */ || type === "next" /* ButtonType.Next */) &&
            currentPage >= totalPages);
    const { btnClass, label, isLabelProvided, page } = {
        ["previous" /* ButtonType.Prev */]: {
            btnClass: classes.navButtonPrevious,
            label: previousLabel || React.createElement(ChevronLeft, { "aria-hidden": true }),
            isLabelProvided: !!previousLabel,
            page: currentPage - 1,
        },
        ["next" /* ButtonType.Next */]: {
            btnClass: classes.navButtonNext,
            label: nextLabel || React.createElement(ChevronRight, { "aria-hidden": true }),
            isLabelProvided: !!nextLabel,
            page: currentPage + 1,
        },
        ["first" /* ButtonType.First */]: {
            btnClass: classes.navButtonFirst,
            label: firstLabel || React.createElement(DoubleChevronLeft, { "aria-hidden": true }),
            isLabelProvided: !!firstLabel,
            page: 1,
        },
        ["last" /* ButtonType.Last */]: {
            btnClass: classes.navButtonLast,
            label: lastLabel || React.createElement(DoubleChevronRight, { "aria-hidden": true }),
            isLabelProvided: !!lastLabel,
            page: totalPages,
        },
    }[type];
    const defaultButtonProps = {
        'data-hook': DataHooks[type],
        id: getId(id, 'navButton' + upperCaseFirst(type)),
        'aria-label': !isLabelProvided ? upperCaseFirst(type) + ' Page' : undefined,
    };
    return pageUrl && !isDisabled ? (React.createElement("a", { className: st(classes.navButton, { disabled: isDisabled }, btnClass), href: pageUrl(page), onClick: (event) => handlePageClick(event, page), ...defaultButtonProps }, label)) : (React.createElement("button", { className: st(classes.navButton, { disabled: isDisabled }, btnClass), disabled: isDisabled, onClick: !isDisabled ? (event) => handlePageClick(event, page) : null, ...defaultButtonProps }, label));
};
//# sourceMappingURL=NavButton.js.map